import component from './LayoutHeaderless.vue'
export default component
